import Box from '@mui/material/Box';
import { Card, ControlledTextField } from '../../../../shared/components';

export default function AccountingIdentifiersSection() {
  return (
    <Card>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          columnGap: 8,
          rowGap: 2,
        }}
      >
        <ControlledTextField
          name='jobCode'
          id='job-code'
          label='Job Code'
          placeholder='Enter job code'
          rules={{ required: 'Job code is required' }}
          showErrorInline
          orientation='row'
          fullWidth
          wrapperSx={{ flex: 1, '& > div': { gridTemplateColumns: '15rem 1fr' } }}
        />

        <ControlledTextField
          name='details.documentReferenceNumber'
          id='document-reference-number'
          label='Document Reference Number'
          placeholder='Enter reference number'
          rules={{ required: 'Document reference number is required' }}
          showErrorInline
          fullWidth
          orientation='row'
          wrapperSx={{ flex: 1, '& > div': { gridTemplateColumns: '15rem 1fr' } }}
        />
      </Box>
    </Card>
  );
}
